import { render } from "./BonusPack.vue?vue&type=template&id=05f471ba&scoped=true"
import script from "./BonusPack.vue?vue&type=script&lang=js"
export * from "./BonusPack.vue?vue&type=script&lang=js"

import "./BonusPack.vue?vue&type=style&index=0&id=05f471ba&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05f471ba"]])

export default __exports__